export default {"src":"/_next/static/media/features-block-promotional-emails.961f14b1.svg","height":410,"width":503,"blurWidth":0,"blurHeight":0};